module.exports = __webpack_public_path__ + "static/media/handtohand.5b5f2d32.png";